
export enum UnitBusinessAnnualRevenue {
    UpTo250k = 1,
    Between250kAnd500k = 2,
    Between500kAnd1m = 3,
    Between1mAnd5m = 4,
    Over5m = 5,
}

export namespace UnitBusinessAnnualRevenue {
    export function toString(unitRevenue: UnitBusinessAnnualRevenue): string {
        switch (unitRevenue) {
            case UnitBusinessAnnualRevenue.UpTo250k:
                return '$0 - $250,000';
            case UnitBusinessAnnualRevenue.Between250kAnd500k:
                return '$250,000 - $500,000';
            case UnitBusinessAnnualRevenue.Between500kAnd1m:
                return '$500,000 - $1 million';
            case UnitBusinessAnnualRevenue.Between1mAnd5m:
                return '$1 million - $5 million';
            case UnitBusinessAnnualRevenue.Over5m:
                return '$5+ million';
            default:
                return '';
        }
    }

    export function listAll(): UnitBusinessAnnualRevenue[]{
        return [
            UnitBusinessAnnualRevenue.UpTo250k,
            UnitBusinessAnnualRevenue.Between250kAnd500k,
            UnitBusinessAnnualRevenue.Between500kAnd1m,
            UnitBusinessAnnualRevenue.Between1mAnd5m,
            UnitBusinessAnnualRevenue.Over5m,
        ]
    }

    export function parse(str:string): UnitBusinessAnnualRevenue{
        return UnitBusinessAnnualRevenue[str];
    }
}